import {DataSource} from "@/datasources/consulte-grid";
import {SalaModel} from '@/models/gestao/sala/sala.model';
import SalaService from "@/services/gestao/sala/sala.service";

export default class SalaDataSource extends DataSource<SalaModel> {
 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: SalaModel[], onLoad?: (rows: any) => void) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<SalaModel>())
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await SalaService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters)).data as any) as DataSource<SalaModel>;
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
